import { useState, useEffect } from 'react';

export const useSuperadmin = () => {
  const [isSuperadminUser, setIsSuperadminUser] = useState(false);

  useEffect(() => {
    const email = localStorage.getItem('user_email');
    if (email && 
        (email.toLowerCase() === 'superadmin@srcp.site' 
        || email.toLowerCase() === 'phuocquach.nt@gmail.com')
    ) {
      setIsSuperadminUser(true);
    } else {
      setIsSuperadminUser(false);
    }
  }, []);

  return isSuperadminUser;
};